export default __webpack_public_path__ + "static/media/menu-medical-record-icon.6c2296b4.svg";